declare global {
  interface Window {
    jQuery: (nodeOrSelector: string) => HTMLElement | string;
  }
}

(function () {
  window.jQuery =
    window.jQuery ||
    function (nodeOrSelector: unknown) {
      if (typeof nodeOrSelector === 'string') {
        return document.querySelector(nodeOrSelector);
      }
      return nodeOrSelector;
    };
})();
